class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            mainAddToCart: ".m-add-to-cart", // Main Add to Cart button
            stickyAtcContainer: ".m-sticky-addtocart", // Sticky ATC container
            variantSelect: '[name="id"]' // Variant selector
        };

        this.init();
    }

    init() {
        this.container = document.querySelector(this.selectors.stickyAtcContainer);
        this.mainAddToCart = document.querySelector(this.selectors.mainAddToCart);
        this.variantSelect = this.querySelector(this.selectors.variantSelect);

        if (this.container && this.mainAddToCart) {
            this.observeMainAtc();
        }
        
        this.syncVariantSelection();
    }

    observeMainAtc() {
        const mainAtcRect = this.mainAddToCart.getBoundingClientRect(); // Get the position of main ATC
        const offset = mainAtcRect.top + window.scrollY + mainAtcRect.height; // Get bottom position

        const checkScroll = () => {
            if (window.scrollY > offset) {
                this.showStickyAtc();
            } else {
                this.hideStickyAtc();
            }
        };

        window.addEventListener("scroll", checkScroll);
        checkScroll(); // Run check initially in case user loads mid-page
    }

    showStickyAtc() {
        this.container.style.transform = "translateY(0)";
        this.container.style.opacity = "1";
        document.documentElement.classList.add("stick-atc-show");
    }

    hideStickyAtc() {
        this.container.style.transform = "translateY(100%)";
        this.container.style.opacity = "0";
        document.documentElement.classList.remove("stick-atc-show");
    }

    syncVariantSelection() {
        if (!this.variantSelect) return;

        window.MinimogEvents.subscribe("VARIANT_CHANGE", (variant) => {
            this.variantSelect.value = variant.id;
        });
    }
}

// Register the custom element
if (!customElements.get("sticky-atc")) {
    customElements.define("sticky-atc", StickyAddToCart);
}